import { CSSObject, css } from '@emotion/react'

export const emojiButtonOverrides: CSSObject = {
  blockSize: 27,
  paddingInline: 4,

  '.lapidary-button-icon': {
    // chrome doesn't render frowning face correctly in
    // sans-serif fonts
    fontFamily: 'serif',
  },
}

export const listItem = css({
  display: 'block',
})
